import { alpha } from '@mui/material'

import { primary } from '@/Theme/colors'

const tableBackgroundColor = '#FFFFFF'

export const tableBorderColor = 'rgba(0, 0, 0, 0.12)'
export const cellBorder = `1px solid ${tableBorderColor}`

const tableCellStyle = {
  fontSize: '16px',
  borderBottom: cellBorder,
  borderRight: cellBorder,
  paddingTop: '10px',
  paddingBottom: '10px',
  paddingLeft: '16px',
  paddingRight: '16px',
  outline: 0,
  fontWeight: 400,
  '& p': {
    fontSize: '16px'
  },
  '& > div': {
    display: 'flex',
    fontSize: '16px'
  },
  '&:last-child': {
    borderRight: 0
  },
  '@media print': {
    fontSize: '12px',
    '& .MuiTypography-root': {
      fontSize: '12px !important'
    },
    '& p': {
      fontSize: '12px !important'
    },
    '& > div': {
      fontSize: '12px !important'
    }
  }
}

const tableHeaderCellStyle = {
  fontSize: '16px',
  fontWeight: 600,
  color: 'rgba(0, 0, 0, 0.87) !important',
  backgroundColor: alpha(primary.main, 0.12),
  paddingTop: '10px',
  paddingBottom: '10px',
  paddingLeft: '16px',
  paddingRight: '16px',
  lineHeight: 1.5
}

export const tableComponentOverrides = {
  MuiTable: {
    styleOverrides: {
      root: {
        border: 0 // @see ResponsiveTableContainer - it is wrapped in a Paper component that adds the border
      }
    }
  },
  MuiTableContainer: {
    styleOverrides: {
      root: {
        backgroundColor: tableBackgroundColor,
        border: cellBorder,
        borderRadius: 4
      }
    }
  },
  MuiTableCell: {
    styleOverrides: {
      head: tableHeaderCellStyle,
      root: tableCellStyle
    }
  },
  MuiTableRow: {
    styleOverrides: {
      head: {
        '&.MuiTableRow-root': {
          borderBottom: 0
        }
      },
      root: {
        '&.MuiTableRow-hover': {
          cursor: 'pointer'
        }
      }
    }
  }
}
